<template>
  <div
    id="Software"
    class="container"
  >
    <div class="row">
      <div
        id="left"
        class="col-md-3 col-sm-3 hidden-xs"
      >
        <left-nav
          :leftMenuList="leftMenuList"
          :nowId="21"
        >
        </left-nav>
        <!-- <ul class="left-container wow bounceInLeft" >
                    <p>软件产品</p>
                    <li v-for="(item,index) in softwareList" :key="index">
                        <router-link :to=item.path>{{item.name}}</router-link>
                    </li>
                </ul> -->
      </div>
      <div
        id="right"
        class="col-md-9 col-sm-9 col-xs-12  wow container-fluid"
      >
        <div
          class="title"
          style="border-bottom: 1px solid #ebebeb;"
        >
          {{ $t("message.i18n_25") }}
          <div class="underline">
            <!-- 下划线样式，勿删 -->
          </div>
          <div>

          </div>
        </div>
        <div
          class="row"
          style="border-bottom: 1px solid #ebebeb;height: 80px;margin-bottom: 20px;"
        >
          <div class="col-md-9 col-sm-9 hidden-xs">
            <p style="line-height: 80px;">
              <span>{{ $t("message.i18n_26") }}： </span>
              <span
                style="color: #007AFF;cursor: pointer;margin-right: 4px;"
                v-for="(item,index) in ratingCodeList"
                :key="index + 'key'"
                v-if="index < 4"
                @click="handleSearchlocation(item)"
              >{{item}} </span>
            </p>
          </div>

          <div class="col-md-3 col-sm-3 col-xs-12">
            <!-- <input type="text"> -->
            <!-- <div class="searchInputBox">
              <input
                type="text"
                class="input"
                @keydown.enter="handleSearchlocation()"
                v-model="ratingCode"
                :placeholder="$t('message.i18n_2')"
                style="width: 100%;border: none;height: 30px;padding-left: 10px;"
              >
              <span
                class="tip"
                @click="handleSearchlocation()"
              >{{ $t("message.i18n_1") }}</span>
            </div> -->
          </div>
        </div>
        <div
          class="alert alert-warning"
          role="alert"
          style="background-color: #8C1A11;color: #fff;font-size: 10px;font-weight: 500;"
          v-if="getInfo.recoverSign == 1"
        >
          <!-- 追回 -->
          {{getInfo.recoverRemark}}
        </div>
        <div
          class="row"
          id="div_pic"
          v-if="getInfo && searchSuccess"
          style="display: flex;overflow-x: auto;margin-bottom: 10px;"
        >
          <div
            v-if="getInfo.imgList.length > 0"
            class="col-xs-6 col-sm-3 col-md-3"
            style="flex-shrink:0;margin-bottom: 8px;"
            v-for="(item,index) in getInfo.imgList"
            :key="index + 'key'"
          >
            <img
              :src="item.list"
              alt=""
              class="img-responsive"
              @click="showImg(index)"
              @error="imageLoad($event,index)"
            >
          </div>
          <p
            class="text-center"
            style="width: 100%;"
            v-if="getInfo.imgList.length == 0"
          >- {{ $t("message.i18n_30") }} -</p>
        </div>

        <!-- <div
          class="alert alert-warning"
          role="alert"
          v-if="getInfo.goodsNotes"
          style=";background-color: rgba(245, 194, 133, 0.2);color: #FFAD4C;font-size: 10px;font-weight: 500;"
        >
          {{getInfo.goodsNotes}}
        </div> -->
        <div
          class="alert alert-warning"
          v-if="getInfo.ratingResult == 0 || getInfo.ratingResult == 6"
          role="alert"
          style="background-color: #F5C285;color: #8C1A11;font-size: 10px;font-weight: bold;"
        >
          <!-- 退回 -->
          {{ $t("message.i18n_31") }}，{{ $t("message.i18n_32") }}
        </div>
        <viewer
          :images="getInfo.imgList"
          ref="viewer"
          @inited="inited"
        >
          <!-- //photo 一定要一个数组，否则报错 -->
          <img
            class="goodImg"
            v-for="(item,index) in getInfo.imgList"
            v-show="false"
            :src="item.self"
            :data-source="item.self"
            :key="index"
            @load="imgLoad"
            alt="picture size"
          >
          <!--  <img
				                v-for="(src,index) in photo"
				                :src="src"
				                :key="index"
				                :onerror="errorImg"
				              > -->
        </viewer>

        <div
          class="conatiner-fuild"
          v-if="searchSuccess"
        >
          <div style="font-size: 14px;margin: 10px 0;text-align: center;">提示：若本评级盒被打开、损坏或篡改，将不享受本公司后续质保服务。</div>
          <!-- 非套盒展示 -->
          <div
            class="row"
            style="padding:0 17px;"
            v-if="!getInfo.boxDetails"
          >
            <div
              class="col-xs-3 col-sm-2"
              style="border: 1px solid #EBEBEB;padding: 0;border-bottom: none;"
            >
              <div class="searchBoxLeft">
                评级编号
              </div>
              <div class="searchBoxLeft">
                名称
              </div>
              <div
                class="searchBoxLeft"
                v-if="getInfo.ratingResult == 1 && getInfo.goodsScoreName"
              >
                分数
              </div>
              <div
                class="searchBoxLeft"
                v-if="getInfo.ratingResult == 1 && getInfo.goodsDefect && String(getInfo.ratingCode).length == 10"
              >
                瑕疵
              </div>
              <div
                class="searchBoxLeft"
                v-if="getInfo.ratingResult == 1 && getInfo.goodsSize"
              >
                尺寸
              </div>
              <div v-if="getInfo.ratingResult == 1 &&  String(getInfo.ratingCode).length == 10">
                <div
                  class="searchBoxLeft"
                  v-for="(item,index) in getInfo.attr"
                   v-if="(getInfo.goodsSize ? showName.includes(item.split('：')[0]) == false : true)"
                >
                <span>
                  {{item.split('：')[0]}}
                </span>
                </div>
              </div>
              <!-- 统计 -->
              <div
                class="searchBoxLeft"
                v-if="getInfo.ratingResult == 1 &&  String(getInfo.ratingCode).length == 10 && getInfo.countNum && showStatistics.includes(getInfo.category2)"
              >
                统计
              </div>
              <div v-if="getInfo.claimInfo && getInfo.claimInfo!==''">
                <div
                  class="searchBoxLeft"
                  style="height: 80px;line-height: 80px;"
                >
                  真伪赔付等级
                </div>
              </div>
              <div
                v-if="getInfo.goodsNotes"
                class="searchBoxLeft"
              >备注</div>
            </div>
            <div
              class="col-xs-9 col-sm-10"
              style="border: 1px solid #EBEBEB;padding: 0;border-bottom: none;"
            >
              <div class="searchBoxRight">
                {{getInfo.ratingCode}}
              </div>
              <div class="searchBoxRight">
                {{getInfo.goodsName}}
              </div>
              <div
                class="searchBoxRight"
                v-if="getInfo.ratingResult == 1 && getInfo.goodsScoreName"
              >
                {{getInfo.goodsScoreName}}
              </div>
              <div
                class="searchBoxRight"
                v-if="getInfo.ratingResult == 1 && getInfo.goodsDefect &&  String(getInfo.ratingCode).length == 10"
                style="display: flex;justify-content: space-between;"
              >
                <span style="font-weight: bold;">{{getInfo.goodsDefect ?'(' + getInfo.goodsDefect + ')' : ''}} {{getInfo.goodsDefectName ? getInfo.goodsDefectName : ''}}</span>
                <span
                  style="cursor: pointer; color: #007AFF;margin-right: 10px;"
                  @click="toDefect()"
                >瑕疵说明</span>
              </div>
              <div
                class="searchBoxRight"
                v-if="getInfo.ratingResult == 1 && getInfo.goodsSize"
              >
                {{getInfo.goodsSize}}
              </div>
              <div
                class="searchBoxRight"
                v-for="(item,index) in getInfo.attr"
                v-if="item && getInfo.ratingResult == 1 &&  String(getInfo.ratingCode).length == 10 && (getInfo.goodsSize ? showName.includes(item.split('：')[0]) == false : true)"
              >
                {{item.split('：')[1]}}
              </div>
              <!-- 统计 -->
              <div
                class="searchBoxRight"
                v-if="getInfo.ratingResult == 1  &&  String(getInfo.ratingCode).length == 10 && getInfo.countNum && showStatistics.includes(getInfo.category2)"
                style="display: flex;justify-content: space-between;"
              >
                <div
                  style="font-weight: bold;"
                  class="hidden-xs"
                >
                  <span
                    style="font-weight: bold;margin-right: 2px;"
                    v-if="getInfo.goodsScoreName"
                  >{{getInfo.goodsScoreName}}</span> 数量:{{getInfo.countNum}}
                  <span style="font-size: 10px;">(</span>{{getInfo.countRemark}} <span
                    v-if="getInfo.countRemark"
                    style="font-size: 10px;"
                  >/</span> <span style="color: red;font-size: 10px;">仅供参考</span> <span style="font-size: 10px;">)</span>
                </div>
                <div class="hidden-xs">
                  <span
                    style="cursor: pointer; color: #007AFF;margin-right: 10px;white-space: nowrap;"
                    @click="toSearchCount(getInfo.coinName)"
                  >{{ $t("message.i18n_33") }}</span>
                </div>
                <div
                  style="font-weight: bold; line-height: 15px;margin-top: 5px;"
                  class="visible-xs"
                >
                  <span
                    style="font-weight: bold;margin-right: 2px;"
                    v-if="getInfo.goodsScoreName"
                  >{{getInfo.goodsScoreName}}</span> 数量:{{getInfo.countNum}}
                  <br />
                  <span style="font-size: 10px;">(</span>注：数量{{getInfo.countRemark}} <span
                    v-if="getInfo.countRemark"
                    style="font-size: 10px;"
                  >/</span> <span style="color: red;font-size: 10px;">仅供参考</span> <span style="font-size: 10px;">)</span>
                </div>
                <div class="visible-xs">
                  <span
                    style="cursor: pointer; color: #007AFF;margin-right: 10px;white-space: nowrap;"
                    @click="toSearchCount(getInfo.coinName)"
                  >{{ $t("message.i18n_33") }}</span>
                </div>
              </div>
              <div
                v-if="getInfo.claimInfo && getInfo.claimInfo!='' "
                class="searchBoxRight"
                style="height: 80px;padding: 10px 20px;"
              >
                <div style="height: 20px;line-height: 20px; font-weight: bold"> {{getInfo.claimInfo}}</div>
                <div style="height: 40px;line-height: 20px; ">
                  <div> 此赔付等级根据送评时所交评级费的标准价而定</div>
                  <div> 友情提醒:如市场价格已超出赔付等级，可申请重新评级，增加评级费升档，以避免风险和损失。</div>
                </div>
              </div>
              <div
                v-if="getInfo.goodsNotes"
                class="searchBoxRight"
              >{{getInfo.goodsNotes}} </div>

            </div>

            <!-- <div style="border: 1px solid #EBEBEB;">
							展开
						</div> -->
          </div>

          <!-- 套盒展示 -->
          <div
            class="row"
            style="padding:0 17px;"
            v-if="getInfo.boxDetails"
          >
            <div
              class="col-xs-3 col-sm-2"
              style="border: 1px solid #EBEBEB;padding: 0;border-bottom: none;"
            >
              <div class="searchBoxLeft">
                评级编号
              </div>
              <div class="searchBoxLeft">
                名称
              </div>
            </div>
            <div
              class="col-xs-9 col-sm-10"
              style="border: 1px solid #EBEBEB;padding: 0;border-bottom: none;"
            >
              <div class="searchBoxRight">
                {{getInfo.ratingCode}}
              </div>
              <div class="searchBoxRight">
                {{getInfo.goodsName}}
              </div>
            </div>
          </div>
          <div
            class="row"
            style="padding:0 17px;"
            v-if="getInfo.boxDetails"
          >
            <div style="text-align: center;height: 40px;line-height: 40px;">
              <div
                style="cursor: pointer;color: #999999;font-weight: 400;font-size: 14px;display: flex;margin: 0 auto;width:80px;"
                @click="showDetails = !showDetails"
              >
                {{ $t("message.i18n_34") }}
                <div v-if="showDetails">
                  <img
                    src="../assets/img/upOrDown.png"
                    alt=""
                    style="transform:rotate(180deg);width: 14px;height: 14px;margin-top: 13px;margin-left: 2px;"
                  >
                </div>
                <div v-if="!showDetails">
                  <img
                    src="../assets/img/upOrDown.png"
                    alt=""
                    style="width: 14px;height: 14px;margin-top: 13px;margin-left: 2px;"
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- 套盒数据展示 -->
          <div
            v-if="getInfo.boxDetails && showDetails"
            v-for="(arr,each) in getInfo.boxDetails"
            :key="each + 'index'"
          >
            <div
              class="row"
              style="padding:0 17px;"
              :style="{marginBottom:( each == getInfo.boxDetails.length - 1?'0px':'22px')}"
            >
              <div
                class="col-xs-3 col-sm-2"
                style="border: 1px solid #EBEBEB;padding: 0;border-bottom: none;"
              >
                <div class="searchBoxLeft">
                  评级编号
                </div>
                <div class="searchBoxLeft">
                  名称
                </div>
                <div
                  class="searchBoxLeft"
                  v-if="arr.ratingResult == 1 && arr.goodsScoreName"
                >
                  分数
                </div>
                <div
                  class="searchBoxLeft"
                  v-if="arr.ratingResult == 1 && arr.goodsDefect && String(arr.ratingCode).length == 10"
                >
                  瑕疵
                </div>
                <div
                  class="searchBoxLeft"
                  v-if="arr.ratingResult == 1 && arr.goodsSize"
                >
                  尺寸
                </div>
                <div v-if="arr.ratingResult == 1 && String(arr.ratingCode).length == 10">
                  <div
                    class="searchBoxLeft"
                    v-for="(item,index) in arr.attr"
                    v-if="(arr.goodsSize ? showName.includes(item.split('：')[0]) == false : true)"
                  >
                    {{item.split('：')[0]}}
                  </div>
                </div>
                <div v-if="getInfo.claimInfo && getInfo.claimInfo!=='' ">
                  <div
                    class="searchBoxLeft"
                    style="height: 80px;line-height: 80px;"
                  >
                    真伪赔付等级
                  </div>
                </div>
                <div
                  v-if="getInfo.goodsNotes"
                  class="searchBoxLeft"
                >备注</div>
              </div>
              <div
                class="col-xs-9 col-sm-10"
                style="border: 1px solid #EBEBEB;padding: 0;border-bottom: none;"
              >
                <div class="searchBoxRight">
                  {{arr.ratingCode}}
                </div>
                <div class="searchBoxRight">
                  {{arr.goodsName}}
                </div>
                <div
                  class="searchBoxRight"
                  v-if="arr.ratingResult == 1 && arr.goodsScoreName"
                >
                  {{arr.goodsScoreName}}
                </div>
                <div
                  class="searchBoxRight"
                  v-if="arr.ratingResult == 1 && arr.goodsDefect && String(arr.ratingCode).length == 10"
                  style="display: flex;justify-content: space-between;"
                >
                  <span style="font-weight: bold;">{{arr.goodsDefect ? '(' + arr.goodsDefect + ')' : ''}} {{arr.goodsDefectName ? arr.goodsDefectName : ''}}</span>
                  <span
                    style="cursor: pointer; color: #007AFF;margin-right: 10px;"
                    @click="toDefect()"
                  >瑕疵说明</span>
                </div>
                <div
                  class="searchBoxRight"
                  v-if="arr.ratingResult == 1 && arr.goodsSize"
                >
                  {{arr.goodsSize}}
                </div>
                <div
                  class="searchBoxRight"
                  v-for="(item,index) in arr.attr"
                  v-if="item && arr.ratingResult == 1 && String(arr.ratingCode).length == 10 && (arr.goodsSize ? showName.includes(item.split('：')[0]) == false : true)"
                >
                  {{item.split('：')[1]}}
                </div>
                <div
                  v-if="getInfo.claimInfo && getInfo.claimInfo!='' "
                  class="searchBoxRight"
                  style="height: 80px;padding: 10px 20px;"
                >
                  <div style="height: 20px;line-height: 20px; font-weight: bold"> {{getInfo.claimInfo}}</div>
                  <div style="height: 40px;line-height: 20px; ">
                    <div> 此赔付等级根据送评时所交评级费的标准价而定</div>
                    <div> 友情提醒:如市场价格已超出赔付等级，可申请重新评级，增加评级费升档，以避免风险和损失。</div>
                  </div>
                </div>

                <div
                  v-if="getInfo.goodsNotes"
                  class="searchBoxRight"
                >{{getInfo.goodsNotes}} </div>

              </div>
            </div>
          </div>
          <div
            class="row"
            style="padding:0 17px;"
          >
            <div style="border: 1px solid #EBEBEB;text-align: center;font-size: 12px;font-weight: bold;">

              <p style="line-height: 50px;font-weight: bold;color: #000000;line-height: 20px;margin: 20px 0;">{{ $t("message.i18n_36") }}<span style="color: #8c1a11;font-weight: bold;font-size: 14px;"> {{getInfo.companyShortName}} </span><span v-if="$store.state.languageVuex == 'zh-CN'">提供</span>
                <span
                  style="color: #333333;"
         
                >，{{ $t("message.i18n_36_1") }}</span>
              </p>
              <p style="color: #999999;margin-top: -20px;">{{ $t("message.i18n_37") }}：<span style="color: #007AFF;">{{getInfo.customerTel}}</span></p>
            </div>
            <div style="text-align: center;font-size: 12px;color: #999999;padding-top: 10px;">
              {{ $t("message.i18n_38") }}
            </div>
          </div>
          <div
            class="row"
            v-if="CoinInfo.goodsDesc"
          >
            <div class="container-fluid">
              <div class="img-responsive">
                <img
                  src="../assets/img/labelGoodsMsg.png"
                  style="width: 100%;"
                >
              </div>
              <div
                v-if="CoinInfo.goodsDesc"
                v-html="CoinInfo.goodsDesc"
              ></div>
            </div>
          </div>
          <div
            class="row"
            style="text-align: center;"
          >
            <span style="font-size: 12px;">
              <span style="color: #999999">{{ $t("message.i18n_39") }}：</span>
              <span
                :class="{'borderRight': index != recommendList.length - 1}"
                v-for="(item,index) in recommendList"
                :key="index + 'key'"
                @click="toWebView(item.link)"
                style="color: #007AFF;cursor: pointer;margin-right: 6px;"
              >
                {{item.title}}
              </span>
            </span>
          </div>

        </div>
        <!-- <p
          class="text-center searchTip"
          v-if="!searchSuccess"
        >{{showMsg}}</p>
     -->

        <div
          class="searchInputBox"
          style="width: 50%;margin: 0 auto;height: 42px"
        >
          <input
            type="text"
            class="input"
            @keydown.enter="handleSearchlocation()"
            v-model="ratingCode"
            :placeholder="$t('message.i18n_2')"
            style="width: 100%;border: none;height: 40px;padding-left: 10px;"
          >
          <span
            class="tip"
            @click="handleSearchlocation()"
          >{{ $t("message.i18n_1") }}</span>
        </div>

        <p
          class="text-center feedbackTip"
          style="cursor: pointer;margin-top: 12px;"
          v-if="!searchSuccess"
          @click="toFeedback"
        >{{ $t("message.i18n_29") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetRatingInfo,
  GetLeftMenuList,
  GETCOININFO,
  GETRECOMMENDWED
} from '../api/api.js'
import {
  GetRatingInfoXY,
  GETRECOMMENDWEDXY
} from '../api/xyapi.js'
import {
  WOW
} from "wowjs";
import LeftNav from '../components/leftNav.vue'
import { JumpCodeList } from './components/index.js'
export default {
  name: 'search',
  components: {
    LeftNav
  },
  data () {
    return {
      searchSuccess: false,
      ratingCodeList: [],
      ratingCode: undefined,
      getInfo: {},
      $viewer1: null,
      leftMenuList: [],
      showMsg: '',
      CoinInfo: '',
      recommendList: undefined,
      showDetails: false,
      JumpCodeList: JumpCodeList,
      showName: ['直径', '重量', '厚度', '重量单位'],
      showStatistics: ['53', '54', '57', '58', '60', '63', 53, 54, 57, 58, 60, 63]
    }
  },
  mounted () {
    if (this.$store.state.languageVuex == 'en') {
      this.showMsg = 'Enter the Number to Query'
    } else {
      this.showMsg = '输入编号进行查询'
    }
    this.ratingCode = this.$route.query.k || this.$route.query.coinsid
    // console.log(this.JumpCodeList,'this.JumpCodeList')
    // this.JumpCodeList.forEach(item => {
    //   if (item.code == this.ratingCode) {
    //     window.location.href = item.url;
    //   }
    // })


    this.getRecommendWed()
    this.getLeftMenuList()

    if (JSON.parse(localStorage.getItem('ratingCode'))) {
      this.ratingCodeList = JSON.parse(localStorage.getItem('ratingCode')).reverse()
    }
    this.getRatingInfo()
    var wow = new WOW();
    wow.init();
  },
  watch: {
    '$route' (newVal) {
      // 监听相同路由下参数变化的时候，从而实现异步刷新
      this.ratingCode = this.$route.query.k || this.$route.query.coinsid
      this.ratingCode = this.$route.query.k || this.$route.query.coinsid
      this.JumpCodeList.forEach(item => {
        if (item.code == this.ratingCode) {
          window.location.href = item.url;
          console.log(item.url, 'uurrll')
        }
      })
      this.getRatingInfo()
    }
  },
  methods: {

    toWebView (url) {
      window.open(url)
    },
    getRecommendWed () {
      let data = {
        type: 3
      }
      GETRECOMMENDWED(data).then((res) => {
        if (res.errorCode == 0) {
          this.recommendList = res.data
          if (!res.data.length) {
            GETRECOMMENDWEDXY(data).then((res) => {
              if (res.errorCode == 0) {
                this.recommendList = res.data
              }
            })
          }
        }
      })
    },
    imageLoad (event, index) {
      var img = event.srcElement
      this.getInfo.imgList.splice(index, 1)
    },
    getLeftMenuList () {
      GetLeftMenuList(21).then(res => {
        let data = {}
        if (this.$store.state.languageVuex == 'en') {
          let objEnglish = JSON.parse(JSON.stringify(res.data).replace(/titleEnglish/g, "enName"))
          let obj = JSON.parse(JSON.stringify(objEnglish).replace(/title/g, "zh-CN"))
          let title = JSON.parse(JSON.stringify(obj).replace(/enName/g, "title"))
          data = title
        } else {
          data = res.data
        }
        this.leftMenuList = data.leftMenuList
      })
    },
    showImg (index) {
      this.$viewer1.index = index
      this.$viewer1.show()
    },
    imgLoad (event) {
    },
    inited (viewer) {
      this.$viewer1 = viewer
    },
    toDefect () {
      this.$router.push({
        path: '/page/singlepage/30',
      })
    },
    toSearchCount (coinName) {
      this.$router.push(
        {
          name: 'scoreCount',
          params: {
            name: coinName,
          },
          query: {
            goodsScore: this.getInfo.goodsScore,
            goodsScoreStatus: this.getInfo.goodsScoreStatus,
            ratingCode: this.getInfo.ratingCode
          }
        })
    },
    toFeedback () {
      this.$router.push({ name: 'feedback' })
    },
    handleSearchlocation (item) {
      this.showDetails = false
      if (item) {
        this.ratingCode = item
        this.$router.push({ name: 'search', query: { k: this.ratingCode } })
      } else {
        this.$router.push({ name: 'search', query: { k: this.ratingCode } })
        this.getRatingInfo()
      }
    },
    getCoinInfo () {
      let data = {
        coinName: this.getInfo.coinName,
      }
      GETCOININFO(data).then((res) => {
        if (res.errorCode) {

        } else {

          this.CoinInfo = res.data.coinInfo
        }
      })
    },
    getRatingInfo () {
      this.getInfo = {}
      // console.log(this.ratingCode,'this.ratingCode')
      if (this.ratingCode) {

      } else {
        this.searchSuccess = false
        if (this.$store.state.languageVuex == 'en') {
          this.showMsg = 'Enter the Number to Query'
        } else {
          this.showMsg = '输入编号进行查询'
        }
        return
      }
      let data = {
        ratingCode: this.ratingCode
      }
      GetRatingInfo(data).then(res => {
        if (res && res.errorCode == 0) {
          // console.log(res.data.jumpUrl,'res.data.jumpUrl')
          if (res.data.jumpUrl && res.data.jumpUrl !== '') {
            window.location.href = res.data.jumpUrl;
          }
          //星卡展示统计
          // res.data.countNum = '10003'
          // res.data.category2 = 52
          // let array = [53, 54, 57, 58, 59, 60]
          //  res.data.statisticsShow = false
          //   array.forEach(item => {
          //    if (res.data.category2 == item) {
          //      res.data.statisticsShow = true
          //    }
          //   })
          // console.log(res.data.statisticsShow, 'res.data.statisticsShow')

          // if(){}

          this.searchSuccess = true
          this.getInfo = res.data
          // console.log(this.getInfo, ' this.getInfo ')
          this.getCoinInfo()
          if (res.data.attrNameJson) {
            this.getInfo.attrNameJson = JSON.parse(res.data.attrNameJson)
          }
          let arr = []
          if (localStorage.getItem('ratingCode')) {
            arr = JSON.parse(localStorage.getItem('ratingCode'))
          } else {

          }
          for (let i = 0; i < arr.length; i++) {
            if (this.ratingCode == arr[i]) {
              arr.splice(i, 1)
              break
            }
          }
          arr.push(this.ratingCode)
          localStorage.setItem('ratingCode', JSON.stringify(arr))
          this.ratingCodeList = JSON.parse(localStorage.getItem('ratingCode')).reverse()
        } else {
          this.searchSuccess = false
          this.showMsg = res.msg
          GetRatingInfoXY(data).then(res => {
            if (res && res.errorCode == 0) {
              this.searchSuccess = true
              this.getInfo = res.data

              this.getCoinInfo()
              if (res.data.attrNameJson) {
                this.getInfo.attrNameJson = JSON.parse(res.data.attrNameJson)
              }
              let arr = []
              if (localStorage.getItem('ratingCode')) {
                arr = JSON.parse(localStorage.getItem('ratingCode'))
              } else {

              }
              for (let i = 0; i < arr.length; i++) {
                if (this.ratingCode == arr[i]) {
                  arr.splice(i, 1)
                  break
                }
              }
              arr.push(this.ratingCode)
              localStorage.setItem('ratingCode', JSON.stringify(arr))
              this.ratingCodeList = JSON.parse(localStorage.getItem('ratingCode')).reverse()
            } else {
              this.searchSuccess = false
              this.showMsg = res.msg
              // console.log(res)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
	.borderRight {
		border-right: 1px solid #007AFF;
	}
	#div_pic{
	            overflow-x: auto;display: -ms-inline-flexbox;display: -webkit-box;-webkit-box-orient: horizontal;/* 横排显示*/
	        }
	        #div_pic::-webkit-scrollbar-track-piece {
	            background-color: rgba(0, 0, 0, 0);
	            border-left: 1px solid rgba(0, 0, 0, 0);
	        }
	        #div_pic::-webkit-scrollbar {
	            width: 5px;
	            height: 13px;
	            -webkit-border-radius: 5px;
	            -moz-border-radius: 5px;
	            border-radius: 5px;
	        }
	        #div_pic::-webkit-scrollbar-thumb {
	            background-color: rgba(0, 0, 0, 0.5);
	            background-clip: padding-box;
	            -webkit-border-radius: 5px;
	            -moz-border-radius: 5px;
	            border-radius: 5px;
	            min-height: 28px;
	        }
	        #div_pic::-webkit-scrollbar-thumb:hover {
	            background-color: rgba(0, 0, 0, 0.5);
	            -webkit-border-radius: 5px;
	            -moz-border-radius: 5px;
	            border-radius: 5px;
	        }
	.searchBoxRight {
		line-height: 40px;
		height: 40px;
		color: #666;
		border-bottom: 1px solid #EBEBEB;
		padding-left: 20px;
		color: #000000;
		font-size: 12px;
		font-weight: bold;
	}
	
	.searchBoxLeft {
		line-height: 40px;
		height: 40px;
		color: #666;
		border-bottom: 1px solid #EBEBEB;
		text-align: right;
		padding-right: 20px;
		font-size: 12px;
	}
	
	.feedbackTip {
		color: #E22434;
		line-height: 16px;
	}
	
	.searchTip {
		margin-top: 40px;
		font-size: 30px;
		line-height: 30px;
		font-weight: 600;
		text-align: center;
		color: #D61E36;
	}
	
	.searchInputBox {
		margin: 24px 0;
		height: 32px;
		position: relative;
		border: 1px solid #ebebeb;
	}
	
	.searchInputBox .tip {
		color: #E22434;
		position: absolute;
		top: 12px;
		right: 12px;
		cursor:pointer
	}
	#left {
		margin: 30px 0;
	}
	
	.left-container {
		width: 60%;
		margin: 0 auto;
		border: 1px solid #474747;
		border-radius: 5px;
	}

	.left-container>p {
		text-align: center;
		line-height: 45px;
		padding: 0;
		margin: 0;
		background: #474747;
		color: #fff;
		font-size: 18px;
		font-weight: bold;
	}

	.left-container>li {
		text-align: center;
		height: 38px;
		line-height: 38px;
		margin: 0;
		border-top: 1px solid #474747;
	}

	.left-container>li>a {
		text-decoration: none;
	}

	.left-container>li:hover {
		background: #928989;
	}

	#right {
		margin: 30px 0;
	}

	#right .title {
		font-size: 22px;
		font-weight: normal;
		color: #545454;
		line-height: 50px;
		border-bottom: 1px solid #ebebeb;
		position: relative;
	}

	#right .title .underline {
		position: absolute;
		bottom: -1px;
		left: 0;
		width: 86px;
		border-bottom: 1px solid #C71625;
	}

	@media screen and (max-width: 768px) {
		#right {
			/* padding: 15px; */
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/search.vue